<template>
  <v-row style="position: relative">
    <v-col v-blur="blurConfig" cols="10">
      <h3 class="d-flex justify-start mb-3">{{ $t('chart.title') }}</h3>
      <p class="d-flex justify-start">{{ $t('chart.subtitle') }}</p>
      <apexchart :options="optionsEfficientFrontier" :series="seriesEfficientFrontier" class="d-flex justify-center" height="400" type="scatter"/>
    </v-col>
    <v-col v-blur="blurConfig" class="d-flex align-center justify-center" cols="2">
      <div>
        <h1 :style="(avgProfit > 0)? 'color: #0F7500' : 'color: #FF4747'">{{ getNumber(avgProfit) }}</h1>
        <h3>{{ $t('indicators_RiskReturnStats.avgProfit') }}</h3>
        <h1 :style="(avgReturn > 0)? 'color: #0F7500' : 'color: #FF4747'" class="mt-5">{{ avgReturn.toFixed(2) }}%</h1>
        <h3>{{ $t('indicators_RiskReturnStats.avgReturn') }}</h3>
        <h1 class="mt-5">{{ stdDeviation.toFixed(2) }}</h1>
        <h3>{{ $t('indicators_RiskReturnStats.stdDeviation') }}</h3>
      </div>
    </v-col>
    <v-overlay :dark="false" v-model="canSeeStat" absolute opacity="0">
      <ProStatAlert @goToPro="goToPro"/>
    </v-overlay>
  </v-row>
</template>

<script>
import ProStatAlert from "@/views/Journal/components/ProStatAlert";
export default {
  name: "RiskReturnStats",
  components: {ProStatAlert},
  data() {
    return {
      blurConfig: {
        isBlurred: !this.$store.state.user.isPro,
        opacity: 0.07,
        filter: "blur(1.2px)",
        transition: "all .3s linear"
      },
      canSeeStat: !this.$store.state.user.isPro,
      avgReturn: 0,
      avgProfit: 0,
      stdDeviation: 0,
      seriesEfficientFrontier: [],
      optionsEfficientFrontier: {
        chart: {
          height: 400,
          type: 'scatter',
        },
        dataLabels: {
          enabled: false
        },
        theme: {
          mode:this.$store.state.currentTheme == "dark"? "dark": "light",
          palette: 'palette2',
        },
        fill: {
          opacity: 0.8
        },
        yaxis: {
          title: {
            text: 'Return Rate'
          },
          labels: {
            formatter: function (value) {
              return `${value.toFixed(1)}%`;
            },
            style: {
              color: '#6C7079',
              fontSize: '12px'
            },
          }
        },
        tooltip: {
          x: {
            show: true,
          },
          y: {
            formatter: function (value, opts) {
              let data = opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex];
              return `${data[0].toFixed(2)}% of risk.<br>${value.toFixed(2)}% of return.`;
            }
          }
        },
        xaxis: {
          type: 'category',
          title: {
            text: 'Risk Percentage'
          },
          labels: {
            formatter: function (value) {
              return `${value.toFixed(2)}%`;
            },
            style: {
              color: '#6C7079',
              fontSize: '12px'
            },
          }
        },
      }
    };
  },
  watch: {
    '$store.state.book.trades': function() {
      this.refreshStats();
    }
  },
  mounted() {
    this.refreshStats();
  },
  methods: {
    refreshStats() {
      this.avgReturn = 0;
      this.avgProfit = 0;
      this.stdDeviation = 0;
      let tradesCount = 0;
      let copyOfTrades = this.$store.state.book.trades.slice();
      copyOfTrades = copyOfTrades.sort((tradeA, tradeB) => tradeA.asset.ticker.localeCompare(tradeB.asset.ticker));
      let currentAsset = '';
      let newData = [];
      copyOfTrades.forEach((trade) => {
        //if (trade.netProfit > 0) {
          if (trade.asset.ticker !== currentAsset) {
            currentAsset = trade.asset.ticker;
            newData.push({
              name: trade.asset.ticker,
              data: [],
            });
          }
          if(trade.accountBalance !== null && trade.mae !== null) {
            newData[newData.length - 1].data.push([((trade.mae / trade.accountBalance) * 100), ((trade.netProfit / trade.accountBalance) * 100)]);
            tradesCount++;
            this.avgProfit += trade.netProfit;
            this.avgReturn += trade.netProfit / trade.accountBalance;
          }
        //}
      });

      if(tradesCount > 0) {
        this.avgProfit /= tradesCount;
        this.avgReturn = (this.avgReturn / tradesCount) * 100;
        copyOfTrades.forEach((trade) => { this.stdDeviation += Math.pow(trade.netProfit - this.avgProfit, 2); });
        this.stdDeviation = Math.sqrt(this.stdDeviation/tradesCount);
      }

      this.seriesEfficientFrontier = newData;
    },
    getNumber(number) {
      return (number > 1000 || number < -1000)? `${(number/1000).toFixed(2)}k` : (number.toFixed(2) * 1).toString();
    },
    goToPro() {
      this.$emit('goToPro');
    }
  }
}
</script>



<style scoped>

</style>
